import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../@core/services/notification.service';
import { NbToastrService } from '@nebular/theme';
import { MenuService } from '../pages-menu';
declare var $: any;

@Component({
  selector: 'ngx-dashboard-manager',
  templateUrl: './dashboard-manager.component.html',
  styleUrls: ['./dashboard-manager.component.scss']
})
export class DashboardManagerComponent implements OnInit {
  form!: FormGroup;
  projectForm!: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  selectedRfqDate: any = "";
  fromRfqDate: any = '';
  toRfqDate: any = '';
  showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false; // RFQ modal visibility flag
paginatestartIndex:number = 0
  paginateendIndex:number = 10
  fromExpectedCompletionDate: any = '';
  toExpectedCompletionDate: any = '';
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  matchedProjectData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  selectedProjectName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  allCustomerData: any[] = [];
  isProjectNameDuplicate: boolean = false;
  isRefresh: boolean = false;
  selectedVersionId: any = null;
  showDutyInput: boolean = false;
  fromAnalysisManager: boolean = false;
  showProjectDropdown: boolean = false;
  filteredProjectNames: string[] = [];
  selectedApprovalProject: any = null;
  approvalReviewComments: string = '';
  projectStatuses: any[] = [];
  selectedApprovalStatus: string = 'Approved';
  showReworkCommentBox: boolean = false;
  isApprovalSubmitting: boolean = false;
  // onQn123: any = {
  //   q1: false, q2: false, q3: false,
  // }
  // allCustomerData = [
  //   {
  //     serialNumber: 100001,
  //     customerName: "John Doe",
  //     city: "New York",
  //     state: "NY",
  //     country: "USA",
  //     gstNumber: "GST12345",
  //     createdBy: "Admin",
  //     createdOn: "2024-10-01",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-11-01",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100002,
  //     customerName: "Jane Smith",
  //     city: "Los Angeles",
  //     state: "CA",
  //     country: "USA",
  //     gstNumber: "GST67890",
  //     createdBy: "Manager",
  //     createdOn: "2024-09-15",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-10-20",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100003,
  //     customerName: "Michael Johnson",
  //     city: "Chicago",
  //     state: "IL",
  //     country: "USA",
  //     gstNumber: "GST24680",
  //     createdBy: "Staff",
  //     createdOn: "2024-08-10",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-09-05",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100004,
  //     customerName: "Emily Davis",
  //     city: "Houston",
  //     state: "TX",
  //     country: "USA",
  //     gstNumber: "GST13579",
  //     createdBy: "Admin",
  //     createdOn: "2024-07-20",
  //     lastModifiedBy: "Manager",
  //     lastModifiedOn: "2024-09-25",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100005,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100006,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: false,
  //   },
  // ];
  engineersData = [];
  thisMonthProjects: any[] = [];
  // allCustomerData = [
  //   {
  //     serialNumber: 1,
  //     projectName: "Project Alpha",
  //     customerName: "Customer A",
  //     rfqDate: new Date("2024-01-15"),
  //     assignedTo: "John Doe",
  //     assignedDate: new Date("2024-01-20"),
  //     expetedCompletionDate: new Date("2024-02-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "50",
  //     status: "In Progress",
  //     currentStage: "procurement",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 2,
  //     projectName: "Project Beta",
  //     customerName: "Customer B",
  //     rfqDate: new Date("2024-02-01"),
  //     assignedTo: "Jane Smith",
  //     assignedDate: new Date("2024-02-05"),
  //     expetedCompletionDate: new Date("2024-03-01"),
  //     targetLeadTime: "3 weeks",
  //     ageing: "1 week",
  //     progress: "30",
  //     status: "In Progress",
  //     currentStage: "Costing",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 3,
  //     projectName: "Project Gamma",
  //     customerName: "Customer C",
  //     rfqDate: new Date("2024-01-10"),
  //     assignedTo: "Alice Johnson",
  //     assignedDate: new Date("2024-01-12"),
  //     expetedCompletionDate: new Date("2024-02-10"),
  //     targetLeadTime: "6 weeks",
  //     ageing: "4 weeks",
  //     progress: "70",
  //     status: "On Hold",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 4,
  //     projectName: "Project Delta",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-01-25"),
  //     assignedTo: "Bob Williams",
  //     assignedDate: new Date("2024-01-30"),
  //     expetedCompletionDate: new Date("2024-03-05"),
  //     targetLeadTime: "5 weeks",
  //     ageing: "3 weeks",
  //     progress: "20",
  //     status: "Delayed",
  //     currentStage: "procurement",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 5,
  //     projectName: "Project Epsilon",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "90",
  //     status: "Not Started",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 6,
  //     projectName: "Project E",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "20%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 7,
  //     projectName: "Project M",
  //     customerName: "Customer M",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-04-15"),
  //     expetedCompletionDate: new Date("2024-06-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "30%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 8,
  //     projectName: "Project M",
  //     customerName: "Customer OR",
  //     rfqDate: new Date("2024-08-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-12-15"),
  //     targetLeadTime: "12 weeks",
  //     ageing: "1 weeks",
  //     progress: "40%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   }
  // ];


  // pageSize: number;
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string = '';
  isSaving: any;
  customerForm: any;
  allCustomerDetails = [];
  userId!: number;
  role: any;
  selectedCustomerId: any;
  currentDate: any;
  assignDate: any;
  projectsData: any;
  editingRowId: number | null = null;
  openStatusCount!: number;
  overdueCount!: number;


  changedstage: any;
  allProjectDetails = [];
  selectedProjectId: any;
  isCustomerNameDuplicate: boolean = false;
  selectedAssigned_to_id: any;
  // selectedCurrentstage: any;
  selectedmatchedCustomerData: any;
  projectNameDetails: any[] = [];
  allOpenProjectDetails: any;
  groupedProjectData: any[] = [];
  currentPageIndex: number = 0;

  rowsPerPage: number | string = 10;

  paginatedData: any[] = [];
  // rowsPerPage = 10; 
  pageSizeOptions: (number | string)[] = [10, 20, 50, 'All'];

  // ========== TAB-RELATED PROPERTIES ==========
  activeTab: number = 1; // Track the active tab (1 = Costing, 2 = Procurement)
  
  // Filtered data for each tab
  costingData: any[] = [];
  procurementData: any[] = [];
  currentTabData: any[] = []; // Data to display based on active tab
  
  // Pagination for each tab
  costingCurrentPage: number = 1;
  procurementCurrentPage: number = 1;
  costingRowsPerPage: any = 10;
  procurementRowsPerPage: any = 10;
  
  // State persistence for navigation
  highlightedProjectId: any = null; // Store project ID for row highlighting
  restoredState: boolean = false; // Flag to prevent multiple restorations

  maxToday: string = '';

  nextMaxDate: string = '';
  isExpectedCompletionDateDisabled: boolean = true;
  onQn123:any = {
    q1: null,  // Landing cost
    q2: null,  // Duties
    q3: null   // Duty Value
  };

  dutyValuePercentage: number = 0;





  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private menuService: MenuService,
    private datePipe: DatePipe,
    private notify: NbToastrService,
    private cdRef: ChangeDetectorRef
  ) {

    const now = new Date();
    // this.currentDate = now.toISOString(); 
    this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.assignDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');


  }

  loadProjectStatuses(): void {
    this.masterService.getProjectStatuses().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.projectStatuses = res.data;
        }
      },
      error: (err: any) => {
        console.error('Error loading project statuses:', err);
      }
    });
  }

  ngOnInit(): void {
    this.loadProjectStatuses();
    this.role = ''
    this.userId = Number(sessionStorage.getItem('user_id'));
    this.role = sessionStorage.getItem('role');

    // Check if coming from analysis-manager
    const navigationState = history.state;
    if (navigationState?.fromAnalysisManager) {
      this.fromAnalysisManager = true;
      console.log("📍 Arrived from Analysis Manager");
    }

    this.projectForm = this.f_builder.group({
      newProjectName: ['', Validators.required],
      projectNo: ['', ],
      description: ['', ],
      customerFullName: ['', Validators.required],
      rfqDate: ['', Validators.required],
      completionDate: ['', Validators.required],
      targetLT: ['', Validators.required],
      assignTo: ['', Validators.required],
      currentStage: ['', Validators.required],
      version_id: [{ value: 1, disable: true }, Validators.required]
    });

    this.customerForm = this.f_builder.group({
      _customerFullName: ['', [Validators.required, Validators.minLength(2)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      gstNumber: ['', [Validators.required]],
    });

    const currentDate = new Date();
    const istDate = new Date(currentDate.getTime() + (5.5 * 60 * 60 * 1000));
    this.maxToday = istDate.toISOString().split('T')[0];
    const nextDay = new Date(istDate);
    nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    this.nextMaxDate = nextDay.toISOString().split('T')[0];

    this.projectForm.get('currentStage')?.valueChanges.subscribe(newStage => {
      if (this.previousStage === 'Costing' && newStage === 'Procurement') {
        console.log("Stage changed: Costing → Procurement");
        this.keepLandingCostValues();
      }
    });

    // ⚡ Load data immediately
    this.getAllcustomers();
    this.getdata();
    
    // Check navigation state to determine which tab to load
    const navState = history.state;
    if (navState?.activeTab === 2) {
      console.log(`📌 Initial load: Restoring activeTab to 2 (procurement tab from navigation)`);
      this.activeTab = 2;
      this.getAllProjectData('procurement');
    } else {
      console.log(`📌 Initial load: Setting activeTab to 1 (costing tab by default)`);
      this.activeTab = 1;
      this.getAllProjectData('costing');
    }
    
    // ⚡ receiveData() is now called AFTER data loads from API in getAllProjectData()
  }

  receiveData(){
    const navigationState = history.state;
    
    if(navigationState && Object.keys(navigationState).length > 0){
      // ⚡ Restore tab state if coming from Project View
      if(navigationState.hasOwnProperty('activeTab')){
        console.log('🔄 Restoring navigation state from Project View');
        this.restoreNavigationState(navigationState);
      }
      
      // ⚡ Apply rows per page if provided
      if(navigationState.hasOwnProperty('rowsPerPage')){
        this.rowsPerPage = navigationState.rowsPerPage || 10;
      }
      
      // ⚡ Apply current page if provided
      if(navigationState.hasOwnProperty('currentPage')){
        this.currentPage = navigationState.currentPage || 1;
        this.paginate();
      }
      
      // ⚡ Handle filter from analysis-manager for open projects
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'open'){
        console.log('🔵 Filtering for Open projects immediately');
        this.onOpenClickedProject(navigationState.filterStatus || 'Open');
      }
      
      // ⚡ Handle filter from analysis-manager to show all projects
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'all'){
        console.log('📊 Showing all projects');
        this.groupedProjectData = this.originalGroupedData;
        this.updateTableRows();
      }
      
      // ⚡ Handle filter from analysis-manager for completion percentage
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'completion'){
        console.log('📈 Filtering by completion:', navigationState.completionRange);
        this.onCompletionFilterClicked(navigationState.completionRange);
      }
    }
    
    history.replaceState({}, '');
  }
  today: Date = new Date();
  isECDGreaterThanToday(dateString: string | Date): boolean {
  if (!dateString) return false;
  const today = new Date();
  const ecdDate = new Date(dateString);
  return ecdDate < today;
}
keepLandingCostValues() {
  // Keep values AS IS – don't modify them
  console.log("Keeping previous Landing Cost values:", this.onQn123, this.dutyValuePercentage);
}



  calculateAgeing(assignedDate: string, status: string, closedDate?: string): number {
    const assignedDateObj = new Date(assignedDate);
    let endDate = new Date();

    if (status === 'Closed' && closedDate) {
      endDate = new Date(closedDate);
    }

    const timeDifference = endDate.getTime() - assignedDateObj.getTime();
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }

  filterProjectNames() {
    const input = this.selectedProjectName.toLowerCase();
    this.filteredProjectNames = this.projectNameDetails.filter(name =>
      name.toLowerCase().includes(input)
    );
  }

  selectProjectName(name: string) {
    this.selectedProjectName = name;
    this.showProjectDropdown = false;
    this.onSelectProject();
  }

  hideDropdown() {

    setTimeout(() => {
      this.showProjectDropdown = false;
    }, 200);
  }

  updateCardCounts(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Use tab-specific data for card counts
    const dataToCount = this.activeTab === 1 ? this.costingData : this.procurementData;

    this.openStatusCount = dataToCount.filter(
      group => group.selectedVersionData?.status === 'Open' || 
               group.selectedVersionData?.status === 'In Progress'
    ).length;

    this.overdueCount = dataToCount.filter(group => {
      const expectedDate = new Date(group.selectedVersionData?.expectedCompletionDate);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && group.selectedVersionData?.status === 'Open';
    }).length;

    this.getThisMonthProjects();
  }

  updateRfqDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {
      let nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.nextMaxDate = nextDay.toISOString().split('T')[0];
      this.isExpectedCompletionDateDisabled = false;
      this.projectForm.get('completionDate')?.enable();
    }
    else {
      this.isExpectedCompletionDateDisabled = true;
      this.projectForm.get('completionDate')?.disable();
    }

  }
  updatecompletionDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {

    }
    else {
      this.projectForm.get('completionDate')?.setValue('');
      this.notify.danger('Please Select the RFQ date Before choosing an Expected Completion Date');

    }
  }

  refreshPage() {
    this.isRefresh = true;
    
    // Preserve the current active tab before resetting
    const currentActiveTab = this.activeTab;
    
    // Reset all tab and pagination states to initial values
    this.resetTabsAndPagination();
    
    // Restore the active tab so user stays on the same tab after refresh
    this.activeTab = currentActiveTab;
    
    // Reset all filters
    this.resetAllFilters();
    
    // Reset upload data
    this.resetFinalData();
    
    // Reload data from APIs with the current tab's stage
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllcustomers();
    this.getdata();
    this.getAllProjectData(currentStage);
  }

  // Reset tabs and pagination to initial state
  private resetTabsAndPagination(): void {
    // Note: activeTab is NOT reset here - caller decides whether to preserve it
    
    // Tab-specific pagination
    this.costingCurrentPage = 1;
    this.procurementCurrentPage = 1;
    this.costingRowsPerPage = 10;
    this.procurementRowsPerPage = 10;
    
    // General pagination
    this.currentPage = 1;
    this.rowsPerPage = 10;
    this.paginatestartIndex = 0;
    this.paginateendIndex = 10;
    
    // Tab data
    this.costingData = [];
    this.procurementData = [];
    this.currentTabData = [];
    this.paginatedData = [];
    
    // State persistence
    this.highlightedProjectId = null;
    this.restoredState = false;
    
    console.log('✅ Tabs and pagination reset to initial state');
  }

  // Reset all filter values
  private resetAllFilters(): void {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.fromExpectedCompletionDate = '';
    this.toExpectedCompletionDate = '';
    this.fromRfqDate = '';
    this.toRfqDate = '';
    this.showProjectDropdown = false;
    this.filteredProjectNames = [];
    
    console.log('✅ All filters reset to initial state');
  }

  // Reset final data (placeholder for dashboard-manager)
  resetFinalData() {
    // Dashboard-manager doesn't have upload functionality like dashboard-engineer
    // This method is kept for consistency with refreshPage() flow
    console.log('✅ Final data reset');
  }

  getdata() {

    let manager_id = {
      'manager_id': Number(this.userId),
    }
    this.masterService.get_manager_and_engineers(manager_id).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result;
        this.engineersData = data.engineers;
        console.log('engineersData', this.engineersData);
        ;
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }
  getAllcustomers() {

    let cus = {
      "operation_type": "READALL"
    }
    this.masterService.all_customers(cus).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        this.allCustomerDetails = result;
        console.log('allCustomerDetails', this.allCustomerDetails);
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve Customer data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the Customer data. Please try again.');
      }
    })
  }


  // Update table rows per page
  updateTableRows() {
    // ⚡ Reset to first page and paginate
    this.currentPage = 1;
    this.paginate();
  }

  paginate() {
    const data = this.groupedProjectData;
    const rows = this.rowsPerPage === 'All' ? data.length : Number(this.rowsPerPage);

    const start = (this.currentPage - 1) * rows;
    const end = this.rowsPerPage === 'All' ? data.length : start + rows;

    this.paginatedData = data.slice(start, end);
  }


  previousPage() {
    if (this.rowsPerPage === 'All') return;

    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginate();
    }
  }

  nextPage() {
    if (this.rowsPerPage === 'All') return;

    const rows = Number(this.rowsPerPage);
    const maxPage = Math.ceil(this.groupedProjectData.length / rows);

    if (this.currentPage < maxPage) {
      this.currentPage++;
      this.paginate();
    }
  }

  // ========== TAB-RELATED METHODS ==========

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    console.log(`📌 Switching from Tab ${this.activeTab} to Tab ${tabNumber}`);
    
    this.activeTab = tabNumber;
    
    // Reset pagination to first page when switching tabs
    this.currentPage = 1;
    
    // Just filter and display for the selected tab from already loaded groupedProjectData
    this.filterAndDisplayTabData();
    this.updateCardCounts();
  }

  // Filter data based on current stage and populate tab-specific data
  filterAndDisplayTabData(): void {
    // Always filter both tabs' data upfront so counts are accurate on initial load
    this.costingData = this.groupedProjectData.filter(
      (item: any) => {
        const stageLower = (item.currentstage || item.currentStage || '').toLowerCase();
        return stageLower === 'costing';
      }
    );
    this.procurementData = this.groupedProjectData.filter(
      (item: any) => {
        const stageLower = (item.currentstage || item.currentStage || '').toLowerCase();
        return stageLower === 'procurement';
      }
    );

    // Set current tab data based on active tab
    if (this.activeTab === 1) {
      // Costing tab
      this.currentTabData = this.costingData;
      this.currentPage = this.costingCurrentPage;
      this.rowsPerPage = this.costingRowsPerPage;
    } else if (this.activeTab === 2) {
      // Procurement tab
      this.currentTabData = this.procurementData;
      this.currentPage = this.procurementCurrentPage;
      this.rowsPerPage = this.procurementRowsPerPage;
    }

    // Update pagination for the selected tab
    this.updateTableRowsForTabs();
  }

  // Restore navigation state after returning from Project View
  restoreNavigationState(navigationState: any): void {
    if (!navigationState || this.restoredState) {
      return;
    }

    console.log('🔄 Restoring: Tab=' + navigationState.activeTab + 
                ' Page=' + navigationState.currentPage + 
                ' ProjectId=' + navigationState.selectedProjectId);
    
    // Restore active tab
    const restoredTab = navigationState.activeTab;
    if (restoredTab) {
      this.activeTab = restoredTab;
    }
    
    // Restore pagination state (for the active tab)
    if (navigationState.currentPage) {
      // Determine which tab's pagination to update
      if (this.activeTab === 1) {
        this.costingCurrentPage = navigationState.currentPage;
        this.currentPage = this.costingCurrentPage;
        if (navigationState.rowsPerPage) {
          this.costingRowsPerPage = navigationState.rowsPerPage;
        }
      } else if (this.activeTab === 2) {
        this.procurementCurrentPage = navigationState.currentPage;
        this.currentPage = this.procurementCurrentPage;
        if (navigationState.rowsPerPage) {
          this.procurementRowsPerPage = navigationState.rowsPerPage;
        }
      }
    }
    
    // Restore pagination display
    this.filterAndDisplayTabData();
    
    // Restore highlighted row
    if (navigationState.selectedProjectId) {
      this.highlightedProjectId = navigationState.selectedProjectId;
      console.log('✅ Row highlighted for project ID:', this.highlightedProjectId);
    }
    
    this.restoredState = true;
  }

  // Update rows for active tab
  updateTableRowsForTabs(): void {
    if (String(this.rowsPerPage) === 'All') {
      this.paginatedData = this.currentTabData;
      this.currentPage = 1;
    } else {
      const rows = Number(this.rowsPerPage);
      const totalPages = Math.ceil(this.currentTabData.length / rows);
      if (this.currentPage > totalPages && totalPages > 0) {
        this.currentPage = totalPages;
      }
      this.paginateForTabs();
    }
  }

  // Paginate for active tab
  paginateForTabs(): void {
    const rows = String(this.rowsPerPage) === 'All' ? this.currentTabData.length : Number(this.rowsPerPage);
    let startIndex = (this.currentPage - 1) * rows;
    let endIndex = startIndex + rows;
    this.paginatedData = this.currentTabData.slice(startIndex, endIndex);
  }

  // Get total pages for active tab
  getTotalPagesForTab(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.currentTabData.length : Number(this.rowsPerPage);
    return Math.ceil(this.currentTabData.length / rows);
  }

  // Get start index for active tab
  getStartIndexForTab(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.currentTabData.length : Number(this.rowsPerPage);
    return (this.currentPage - 1) * rows + 1;
  }

  // Get end index for active tab
  getEndIndexForTab(): number {
    const rows = String(this.rowsPerPage) === 'All' ? this.currentTabData.length : Number(this.rowsPerPage);
    return Math.min(this.currentPage * rows, this.currentTabData.length);
  }


  get startIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return (this.currentPage - 1) * rows + 1;
  }

  get endIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.min(this.currentPage * rows, this.groupedProjectData.length);
  }

  get totalPages(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.ceil(this.groupedProjectData.length / rows);
  }
  originalGroupedData: any[] = [];


  // onOpenClickedProject(status: string) {
  //   console.log('openStatusCount', this.openStatusCount, status)
  //   console.log('this.matchedCustomerData', this.matchedCustomerData);
  //   this.paginatedData = structuredClone(this.groupedProjectData)


  //   this.groupedProjectData = this.paginatedData.slice(0, this.openStatusCount)

  //   this.paginatedData = this.groupedProjectData.filter(customer => customer.status === status);

  //   console.log('Matched Customer Data:', this.paginatedData);
  //   this.updateTableRows();


  // }


  // onOverdueClick() {
  //   const overdueProjects = this.getOverdueItems(this.groupedProjectData);  // use grouped data
  //   this.groupedProjectData = [...overdueProjects];  // display these in table
  //   this.overdueCount = overdueProjects.length; // update count if needed
  //   this.updateTableRows();

  //   console.log('Filtered Overdue Projects:', overdueProjects);
  // }

 onOpenClickedProject(status: string) {
  console.log('🔵 Filtering for status:', status);
  
  // ⚡ Filter directly without deep cloning - huge performance improvement
  this.groupedProjectData = this.originalGroupedData.filter(item =>
    item.selectedVersionData?.status === status ||
    item.selectedVersionData?.status === 'In Progress'
  );

  console.log('✅ Filtered:', this.groupedProjectData.length, 'items');
  this.updateTableRows();
}

onOverdueClick() {
  // ⚡ Filter directly without deep cloning
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  this.groupedProjectData = this.originalGroupedData.filter(item => {
    const expectedDate = new Date(item.selectedVersionData?.expectedCompletionDate);
    expectedDate.setHours(0, 0, 0, 0);
    return expectedDate < today && item.selectedVersionData?.status === 'Open';
  });

  this.updateTableRows();
}

onThisMonthClick() {
  // ⚡ Filter directly without deep cloning
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  this.groupedProjectData = this.originalGroupedData.filter(item => {
    const dt = new Date(item.selectedVersionData?.rfqDate);
    return dt.getMonth() === currentMonth && dt.getFullYear() === currentYear;
  });

  this.updateTableRows();
}

onCompletionFilterClicked(completionRange: string) {
  console.log('📈 Filtering by completion range:', completionRange);
  
  // ⚡ Filter projects based on completion percentage
  this.groupedProjectData = this.originalGroupedData.filter(item => {
    const progress = parseInt(item.selectedVersionData?.progress || '0');
    
    if (completionRange === 'lt50') {
      // <50%: includes 0% and items with progress less than 50
      return progress < 50;
    } else if (completionRange === '50to75') {
      return progress >= 50 && progress <= 75;
    } else if (completionRange === 'gt75') {
      // >75%: only items with progress > 75
      return progress > 75;
    }
    return true;
  });

  console.log('✅ Filtered by completion:', this.groupedProjectData.length, 'items');
  this.updateTableRows();
}

  getOverdueItems(data: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter(item => {
      const expectedDate = new Date(item.selectedVersionData?.expectedCompletionDate);
      expectedDate.setHours(0, 0, 0, 0);
      return expectedDate < today && item.selectedVersionData?.status === 'Open';
    });
  }


  // onThisMonthClick() {
  //   this.getThisMonthProjects(); // Populate thisMonthProjects
  //   this.groupedProjectData = [...this.thisMonthProjects]; // Update table rows
  //   this.updateTableRows();
  // }


  // onSearch(value: any) {

  //   this.searchText = value.target.value;
  //   // this.searchText = this.selectedCustomerName;
  //   const isCustomerExists = this.allCustomerData.some(
  //     (customer:any) => customer.customer_name.toLowerCase() === this.searchText.toLowerCase()
  //   );
  //   this.showAddCustomerButton = this.searchText.trim() !== '' && !isCustomerExists;
  // }
  // onProjectSearch(value: any) {

  //   this.searchText = value.target.value;
  //   // this.searchText = this.selectedCustomerName;
  //   const isProjectExists = this.allProjectDetails.some(
  //     (project:any) => project.projectName.toLowerCase() === this.searchText.toLowerCase()
  //   );
  //   // this.showAddCustomerButton = this.searchText.trim() !== '' && !isProjectExists;
  // }

  onSearch(value: any) {
  this.searchText = value.target.value;

  const isCustomerExists = this.allCustomerData.some(
    (customer: any) => customer.customer_name.toLowerCase() === this.searchText.toLowerCase()
  );

  // Show the 'Add' button only if there's text and customer doesn't exist
  this.showAddButton = this.searchText.trim() !== '' && !isCustomerExists;
}

onProjectSearch(value: any) {
  this.searchText = value.target.value;

  const isProjectExists = this.allProjectDetails.some(
    (project: any) => project.projectName.toLowerCase() === this.searchText.toLowerCase()
  );

  // You can similarly set a flag for project add button if needed
  // this.showAddProjectButton = this.searchText.trim() !== '' && !isProjectExists;
}

  onSelectProject() {
    this.applyAllFilters();
  }

  onSelectCustomer() {
    this.applyAllFilters();
  }

  onSelectEnginner() {
    this.applyAllFilters();
  }

  onSelectStage(eve: any) {
    this.selectedCurrentStage = eve.target.value;
    this.applyAllFilters();
  }

  applyAllFilters() {
    this.matchedCustomerData = this.allCustomerData.filter((cus:any) => {
      const matchProject = this.selectedProjectName ? cus.projectName === this.selectedProjectName : true;
      const matchCustomer = this.selectedCustomerName ? cus.customer_name === this.selectedCustomerName : true;
      const matchEngineer = this.selectedEngineer ? Number(cus.assigned_to_id) === Number(this.selectedEngineer) : true;
      const matchStage = this.selectedCurrentStage ? cus.currentstage === this.selectedCurrentStage : true;

      // Expected Completion Date Range
      const matchExpectedFrom = this.fromExpectedCompletionDate
        ? new Date(cus.expectedCompletionDate) >= new Date(this.fromExpectedCompletionDate)
        : true;

      const matchExpectedTo = this.toExpectedCompletionDate
        ? new Date(cus.expectedCompletionDate) <= new Date(this.toExpectedCompletionDate)
        : true;


      const matchRfqFrom = this.fromRfqDate
        ? new Date(cus.rfqDate) >= new Date(this.fromRfqDate)
        : true;

      const matchRfqTo = this.toRfqDate
        ? new Date(cus.rfqDate) <= new Date(this.toRfqDate)
        : true;


      return matchProject && matchCustomer && matchEngineer && matchStage &&
        matchExpectedFrom && matchExpectedTo && matchRfqFrom && matchRfqTo;
    }).map((cus:any) => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_to_name: cus.assigned_to_name,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      version_id: cus.version_id,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));

    // Group the filtered raw data using groupProjects to handle Costing and Procurement stages correctly
    this.groupedProjectData = this.groupProjects(this.matchedCustomerData);
    this.originalGroupedData = this.groupedProjectData;

    // Filter and update table data/counts for the active tab
    this.filterAndDisplayTabData();
    this.updateCardCounts();
  }


  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
  }
  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
  }
  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
  }

  onSelectCompletionDate() {
    this.selectedRfqDate = '';
    this.applyAllFilters();
  }


  onDateRangeChange() {
    this.selectedExpetedCompletionDate = '';
    console.log('Selected From RFQ Date:', this.fromRfqDate);
    console.log('Selected To RFQ Date:', this.toRfqDate);
    this.applyAllFilters();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.customerName === this.selectedCustomerName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        upload_status: cus.upload_status,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
  }

  back() {
    if (this.fromAnalysisManager) {
      this.router.navigate(['/dashboard-manager/analysis']);
      return;
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal: any) {

    this.modalRef = this.modalService.open(customerModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  resetFields() {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.editProjectRow(null);
    // Reload data maintaining current tab's stage (lowercase for API)
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllProjectData(currentStage);
  }
  previousStage: string | null = null;

 
  openProjectModel(projectModal: any, customer: any, projectId: any) {

  // Store previous project stage (needed for stage-change logic)
  this.previousStage = customer?.currentstage || null;

  if (customer) {
    this.selectedCustomerId = customer.customer_id;
    this.selectedmatchedCustomerData = customer;
    this.selectedProjectId = customer.project_id;
  }

  this.showAddCustomerButton = false;

  this.modalRef = this.modalService.open(projectModal, { 
    ariaLabelledBy: 'modal-basic-title', 
    size: 'lg' 
  });

  this.modalRef.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });

  // ====== EDIT MODE ======
  if (customer) {

    this.patchCustomerData(customer);

    this.onQn123 = {
  q1: customer.q1 == true || customer.q1 == 'true' || customer.q1 == 1 || customer.q1 == 'yes',
  q2: customer.q2 == true || customer.q2 == 'true' || customer.q2 == 1 || customer.q2 == 'yes',
  q3: customer.q3 == true || customer.q3 == 'true' || customer.q3 == 1 || customer.q3 == 'yes',
};


    this.dutyValuePercentage = customer.duty_percentage;

 
    this.showQn2 = this.onQn123.q1;
this.showQn3 = this.onQn123.q2;
this.showDutyInput = this.onQn123.q3;


  } else {

    // ====== ADD MODE ======
    this.projectForm.reset();
    this.projectForm.patchValue({
      version_id: 1
    });
    this.projectForm.get('version_id')?.disable();

    // Reset Landing Cost fields
    this.onQn123 = { q1: null, q2: null, q3: null };
    this.dutyValuePercentage = null as any;

    this.showQn2 = false;
    this.showQn3 = false;
    this.showDutyInput = false;
  }
}

  patchCustomerData(selectedmatchedCustomerData: any) {

    this.projectForm.patchValue({
      newProjectName: selectedmatchedCustomerData.projectName,
      customerFullName: selectedmatchedCustomerData.customer_name,
      rfqDate: selectedmatchedCustomerData.rfqDate,
      completionDate: selectedmatchedCustomerData.expectedCompletionDate,
      targetLT: selectedmatchedCustomerData.targetLeadTime,
      assignTo: selectedmatchedCustomerData.assigned_to_id,
      currentStage: selectedmatchedCustomerData.currentstage,
      version_id: selectedmatchedCustomerData.version_id

    });
    this.projectForm.get('version_id')?.disable();
  }

  onLandinCost(landinCostModal: any) {
    this.modalRef = this.modalService.open(landinCostModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.modalRef.result.then((result) => {

      console.log('Received from modal:', result);
      this.closeResult = `Closed with: ${result}`;



    }, (reason) => {
      console.log('Modal dismissed => ', reason);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
showAddButton: boolean = false;



  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
      this.showAddCustomerButton = false;
    } else {
      this.modalService.dismissAll();
      this.showAddCustomerButton = false;
    }
    this.modalService.dismissAll();
  }


  onAddNewCustomer(event?: any): void {
  this.selectedCustomerId = event?.id;
  console.log('selectedCustomerId', this.selectedCustomerId);
  
  // Hide Add button when a customer is selected
  if (this.selectedCustomerId) {
    this.showAddButton = false;
  }
}

  onSelectProjectName(eve?: any): void {
    this.selectedProjectId = eve?.id;
    console.log('selectedProjectId', this.selectedProjectId);

  }

  enterProject(eve: any): void {
    let enteredProject = eve.target.value.trim(); // Trim to avoid leading/trailing spaces
    this.isProjectNameDuplicate = this.allCustomerData.some(
      (project:any) => project.projectName === enteredProject
    );
  }
  onEnterCustomerName(eve: any): void {
    let enteredCustomer = eve.target.value.trim(); // Trim to avoid leading/trailing spaces
    this.isCustomerNameDuplicate = this.allCustomerDetails.some(
      (customer:any) => customer.customerName === enteredCustomer
    );
  }

  save(): void {
     if (this.onQn123.q1 === null) {
    this.notify.info("Please answer Landing Cost question (Q1).");
    return;
  }
  if (this.onQn123.q1 === true && this.onQn123.q2 === null) {
    this.notify.info("Please answer Duties question (Q2).");
    return;
  }
  if (this.onQn123.q2 === true && this.onQn123.q3 === null) {
    this.notify.info("Please answer Duty Value question (Q3).");
    return;
  }
  if (this.onQn123.q3 === true && (!this.dutyValuePercentage || this.dutyValuePercentage <= 0)) {
    this.notify.info("Please enter a valid Duty Value Percentage.");
    return;
  }
    if (!this.selectedProjectId) {
      let enteredProject:any = this.projectForm.value.newProjectName;
      if (this.isProjectNameDuplicate) {
        return; // Prevent saving if duplicate
      }

      // If there's no selected project ID, check for duplicate project name

      if (this.allCustomerData.some((project:any) => project.projectName === enteredProject)) {
        this.notify.info('Project already available, choose a different Project Name.');
        return; // Prevent saving if duplicate project name is found
      }
    }

    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }

    // Set a flag to indicate that the save process is in progress
    this.isSaving = true;
    let payload: any;

    if (this.projectForm.valid) {
      // Insert logic
      if (!this.selectedProjectId) {
        payload = {
          action: "INSERT",
          project_id: 0,
          version_id: 1,
          projectName: this.projectForm.get('newProjectName')?.value,
             procurement_version_id:0,
          // projectNo: this.projectForm.get('projectNo')?.value,
          // description: this.projectForm.get('description')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.assignDate,
          customer_id: Number(this.selectedCustomerId),
          ageing: 0,
          progress: "0%",
          status: "Open",
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: ""
        };
        this.projectForm.get('version_id')?.disable();
      }

      // Update logic (if selectedProjectId exists)
      if (this.selectedProjectId) {
        payload = {
          action: "UPDATE",
          project_id: this.selectedProjectId,
          version_id: this.selectedmatchedCustomerData.version_id,
          procurement_version_id:0,
          projectName: this.projectForm.get('newProjectName')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.selectedmatchedCustomerData.assigned_date,
          customer_id: Number(this.selectedCustomerId),
          ageing: this.selectedmatchedCustomerData.ageing,
          progress: this.selectedmatchedCustomerData.progress,
          status: this.selectedmatchedCustomerData.status,
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: this.selectedmatchedCustomerData.activestatus
        };
        this.projectForm.get('version_id')?.disable();
      }
    
    
if (this.previousStage === 'Costing' && 
    this.projectForm.get('currentStage')?.value === 'Procurement') {

  payload.q1 = this.selectedmatchedCustomerData.q1;
  payload.q2 = this.selectedmatchedCustomerData.q2;
  payload.q3 = this.selectedmatchedCustomerData.q3;
  payload.duty_percentage = this.selectedmatchedCustomerData.duty_percentage;
}
else {
  // Use current answers
  payload.q1 = this.onQn123.q1 === true;
  payload.q2 = this.onQn123.q2 === true;
  payload.q3 = this.onQn123.q3 === true;
  payload.duty_percentage = this.onQn123.q3 === true ? this.dutyValuePercentage || 0 : 0;
}




      console.log('Final Payload:', payload);
      console.log('payload', payload);

      // Check if currentStage is being changed to Procurement
      const isChangingToProcurement = 
        this.projectForm.get('currentStage')?.value === 'Procurement' &&
        this.previousStage !== 'Procurement' &&
        this.selectedProjectId; // Only for UPDATE mode, not INSERT

      // If changing to Procurement, use MOVE_TO_PROCUREMENT action and calculate sequential procurement_version_id
      if (isChangingToProcurement) {
        payload.action = "MOVE_TO_PROCUREMENT";
        payload.progress = "0%";
        
        // Calculate next sequential procurement_version_id for this project
        const existingProcurementCount = this.allCustomerData.filter((project: any) => 
          project.project_id === this.selectedProjectId && project.currentstage === 'Procurement'
        ).length;
        payload.procurement_version_id = existingProcurementCount + 1;
        
        console.log('🔄 MOVE_TO_PROCUREMENT - Sequential Procurement Version:', payload.procurement_version_id, 'version_id:', payload.version_id, 'with payload:', payload);
      } else {
        // Set procurement_version_id based on current stage
        const currentStage = this.projectForm.get('currentStage')?.value;
        payload.procurement_version_id = currentStage === 'Procurement' ? 1 : 0;
      }

      // API call to save data
      this.masterService.manage_projects(payload).pipe(
        catchError((error) => {
          console.error('Error saving data:', error);
          this.notify.danger('An error occurred while saving the project data. Please try again.');
          return of(null); // Return a fallback observable
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            console.log('Project saved successfully:', response);
            this.notify.success('Project saved successfully.');
            this.projectForm.reset();
            this.closeModal();
            // Reload data maintaining current tab's stage (lowercase for API)
            const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
            this.getAllProjectData(currentStage);
          }
        },
        error: (error) => {
          console.error('Unexpected error:', error);
        },
        complete: () => {
          this.isSaving = false;
          this.closeModal();
          this.projectForm.reset();
        }
      });
    } else {
      this.notify.info('Please fill in all required fields.');
      console.log('Form is invalid');
      this.projectForm.reset();
      this.isSaving = false;
    }
  }



  getThisMonthProjects() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    const dataToFilter = this.activeTab === 1 ? this.costingData : this.procurementData;

    this.thisMonthProjects = dataToFilter.filter(group => {
      const rfqDate = new Date(group.rfqDate);
      return rfqDate.getMonth() === currentMonth && rfqDate.getFullYear() === currentYear;
    });

    console.log("This Month Projects:", this.thisMonthProjects);
  }


  groupProjects(data: any[]): any[] {
    const map = new Map();
    data.forEach((item: any) => {
      const stageVal = item.currentstage || item.currentStage || 'Costing';
      const key = `${item.project_id}_${stageVal}`; // Group by project AND stage
      
      if (!map.has(key)) {
        const processedProgress = item.upload_status?.toLowerCase() === 'new' || item.upload_status?.toLowerCase() === 'inprogress' ? '0%' : item.progress;
        
        map.set(key, {
          ...item,
          // Costing version management
          versions: item.version_ids || [item.version_id],
          versionDetails: [{
            ...item,
            progress: processedProgress,
            version_id: item.version_id
          }],
          selectedVersionData: {
            ...item,
            progress: processedProgress,
            version_id: item.version_id
          },
          // Procurement version management
          procurementVersions: item.procurement_version_ids || (String(stageVal).toLowerCase() === 'procurement' ? [item.procurement_version_id || 0] : []),
          procurementVersionDetails: (item.procurement_version_ids && item.procurement_version_ids.length > 0) || String(stageVal).toLowerCase() === 'procurement' ? [{
            ...item,
            progress: processedProgress,
            procurement_version_id: item.procurement_version_id || 0
          }] : [],
          selectedProcurementVersionData: (item.procurement_version_ids && item.procurement_version_ids.length > 0) || String(stageVal).toLowerCase() === 'procurement' ? {
            ...item,
            progress: processedProgress,
            procurement_version_id: item.procurement_version_id || 0
          } : null
        });
      } else {
        const existing = map.get(key);
        const processedProgress = item.upload_status?.toLowerCase() === 'new' || item.upload_status?.toLowerCase() === 'inprogress' ? '0%' : item.progress;
        
        const isCosting = String(stageVal).toLowerCase() === 'costing' || (item.version_ids && item.version_ids.length > 0);
        const isProcurement = String(stageVal).toLowerCase() === 'procurement' || (item.procurement_version_ids && item.procurement_version_ids.length > 0);
        
        if (isCosting) {
          if (!existing.versions.includes(item.version_id)) {
            existing.versions.push(item.version_id);
          }
          if (!existing.versionDetails.find((v: any) => v.version_id === item.version_id)) {
            existing.versionDetails.push({
              ...item,
              progress: processedProgress,
              version_id: item.version_id
            });
          }
        } else if (isProcurement) {
          const procVerId = item.procurement_version_id || 0;
          if (!existing.procurementVersions.includes(procVerId)) {
            existing.procurementVersions.push(procVerId);
          }
          if (!existing.procurementVersionDetails.find((v: any) => v.procurement_version_id === procVerId)) {
            existing.procurementVersionDetails.push({
              ...item,
              progress: processedProgress,
              procurement_version_id: procVerId
            });
          }
        }
      }
    });

    // Sort versions descending and set selectedVersionData to latest
    const groups = Array.from(map.values());
    groups.forEach(group => {
      group.versions.sort((a: number, b: number) => b - a);
      group.procurementVersions.sort((a: number, b: number) => b - a);

      if (group.versions.length > 0) {
        const latestVersionId = group.versions[0];
        const latestVersion = group.versionDetails.find((v: any) => v.version_id === latestVersionId);
        if (latestVersion) {
          group.selectedVersionData = { ...latestVersion };
        }
      }

      if (group.procurementVersions.length > 0) {
        const latestProcVersionId = group.procurementVersions[0];
        const latestProcVersion = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === latestProcVersionId);
        if (latestProcVersion) {
          group.selectedProcurementVersionData = { ...latestProcVersion };
          group.selectedVersionData = { ...latestProcVersion };
        }
      }
    });

    return groups;
  }

  loadBothStages(onComplete?: () => void): void {
    this.isRefresh = true;
    this.allCustomerData = [];
    this.matchedCustomerData = [];
    this.groupedProjectData = [];

    let costingGroupedData: any[] = [];
    let procurementGroupedData: any[] = [];
    let costingRawData: any[] = [];
    let procurementRawData: any[] = [];
    let stagesLoaded = 0;

    const onStageComplete = () => {
      stagesLoaded++;
      if (stagesLoaded === 2) {
        // Merge both stages' raw data
        this.allCustomerData = [...costingRawData, ...procurementRawData];
        this.matchedCustomerData = [...costingRawData, ...procurementRawData];

        // Merge both stages' grouped data
        this.groupedProjectData = [...costingGroupedData, ...procurementGroupedData];
        this.originalGroupedData = this.groupedProjectData;

        // Extract unique project names
        this.projectNameDetails = Array.from(
          new Set(this.groupedProjectData
            .filter((item: any) => item.projectName)
            .map((item: any) => item.projectName.trim()))
        );

        this.filterAndDisplayTabData();
        this.updateTableRowsForTabs();
        this.updateCardCounts();
        this.receiveData();

        this.isRefresh = false;

        if (onComplete) {
          onComplete();
        }
      }
    };

    // Load Costing Stage
    const costingPayload = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: this.userId,
      currentstage: 'costing'
    };

    this.masterService.manage_projects(costingPayload).subscribe({
      next: (result: any) => {
        if (result && result.status === 'success' && result.data) {
          const sorted = result.data.sort((a: any, b: any) => {
            if (a.created_date && b.created_date) {
              return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
            }
            return b.project_id - a.project_id;
          });
          costingRawData = sorted;
          costingGroupedData = this.groupProjects(sorted);
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('Error loading costing data:', error);
        onStageComplete();
      }
    });

    // Load Procurement Stage
    const procurementPayload = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: this.userId,
      currentstage: 'procurement'
    };

    this.masterService.manage_projects(procurementPayload).subscribe({
      next: (result: any) => {
        if (result && result.status === 'success' && result.data) {
          const sorted = result.data.sort((a: any, b: any) => {
            if (a.created_date && b.created_date) {
              return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
            }
            return b.project_id - a.project_id;
          });
          procurementRawData = sorted;
          procurementGroupedData = this.groupProjects(sorted);
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('Error loading procurement data:', error);
        onStageComplete();
      }
    });
  }

  getAllProjectData(currentStage: string = 'costing') {
    this.loadBothStages();
  }
  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }
  groupProjectsByVersion(data: any[]) {
    const map = new Map();
    const sortedData = data.sort((a, b) => {
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();
      return dateB - dateA;
    });

    sortedData.forEach(item => {
      const key = `${item.projectName}_${item.rfqDate}_${item.assigned_date}_${item.expectedCompletionDate}`;

      if (!map.has(key)) {
        map.set(key, {
          ...item,
          versions: [item.version_id],
          versionDetails: [item],
          selectedVersionData: item
        });
      } else {
        const existing = map.get(key);
        existing.versions.push(item.version_id);
        existing.versionDetails.push(item);
      }
    });


    this.groupedProjectData = Array.from(map.values());
  }

  onVersionChange(event: any, group: any) {
    const selectedVersionId = Number(event.target.value);
    console.log('🔍 Costing Version Change - selectedVersionId:', selectedVersionId);
    
    let selected = group.versionDetails.find((v: any) => v.version_id === selectedVersionId);
    
    if (!selected) {
      selected = this.allCustomerData.find((v: any) => 
        v.project_id === group.project_id && 
        v.currentstage === group.currentstage &&
        v.version_id === selectedVersionId
      );
    }

    if (selected) {
      group.selectedVersionData = { ...selected };
      this.selectedVersionId = selectedVersionId;
      sessionStorage.setItem('version_id', String(selectedVersionId));
      sessionStorage.setItem('project_id', String(group.project_id));
      console.log('✅ Updated selectedVersionData (Costing):', group.selectedVersionData);
      this.cdRef.detectChanges();
    }
  }

  onProcurementVersionChange(event: any, group: any) {
    const selectedProcurementVersionId = Number(event.target.value);
    console.log('🔍 Procurement Version Change - selectedProcurementVersionId:', selectedProcurementVersionId);
    
    let selected = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === selectedProcurementVersionId);
    
    if (!selected) {
      selected = this.allCustomerData.find((v: any) => 
        v.project_id === group.project_id && 
        v.currentstage === group.currentstage &&
        v.procurement_version_id === selectedProcurementVersionId
      );
    }

    if (selected) {
      const updatedData = {
        ...selected,
        procurement_version_id: selectedProcurementVersionId,
        progress: selected.progress || '0%',
        status: selected.status || 'N/A',
        upload_status: selected.upload_status || 'N/A',
        currentstage: selected.currentstage || group.currentstage
      };
      
      group.selectedProcurementVersionData = updatedData;
      group.selectedVersionData = updatedData;
      
      sessionStorage.setItem('procurement_version_id', String(selectedProcurementVersionId));
      sessionStorage.setItem('project_id', String(group.project_id));
      console.log('✅ Updated selectedVersionData (Procurement):', group.selectedVersionData);
      this.cdRef.detectChanges();
    }
  }

  saveCustomer() {

    if (this.customerForm.invalid || this.isProjectNameDuplicate) {
      // if (this.isProjectNameDuplicate) {
      return; // Prevent saving if duplicate
      // }
    } else {
      // Prevent duplicate API calls
      if (this.isSaving) {
        return;
      }

      // Set a flag to indicate that the save process is in progress
      this.isSaving = true;

      if (this.customerForm.valid) {
       
const payload = {
  customerName: this.customerForm.get('_customerFullName')?.value,
  city: this.customerForm.get('city')?.value.trim(),
  state: this.customerForm.get('state')?.value.trim(),
  country: this.customerForm.get('country')?.value.trim(),
  gstNumber: this.customerForm.get('gstNumber')?.value.trim(),
};

        console.log('payload', payload);

        // API call to save data
        this.masterService.create_customers(payload).pipe(
          catchError((error) => {
            console.error('Error saving data:', error);
            // Handle error by showing a user-friendly message
            // alert('An error occurred while saving the project data. Please try again.');
            this.notify.danger('An error occurred while saving the project data. Please try again.');
            return of(null); // Return a fallback observable
          })
        ).subscribe({
          next: (response) => {
            if (response) {
              console.log('Customer saved successfully:', response);
              // alert('Customer saved successfully.');
              this.notify.success('Customer saved successfully.');
              // Reset the customerForm after success
              this.customerForm.reset();
              this.closeModal();
              this.showAddCustomerButton = false;
            }
          },
          error: (error) => {
            console.error('Unexpected error:', error);
          },
          complete: () => {
            // Reset the saving flag after the process is complete
            this.isSaving = false;
          }
        });
      } else {
        // alert('Please fill in all required fields.');
        this.notify.info('Please fill in all required fields.');
        console.log('Form is invalid');
        // Optionally reset the form if invalid
        this.customerForm.reset();

        // Reset the saving flag
        this.isSaving = false;
      }
      this.modalService.dismissAll();
      this.customerForm.reset();
      this.showAddCustomerButton = false;
    }
    this.getAllcustomers();
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  
onQn1Change(answer: string) {
  if (answer === 'yes') {
    this.showQn2 = true;
    this.onQn123.q1 = true;
  } else {
    this.showQn2 = false;
    this.showQn3 = false;
    this.onQn123.q1 = false;
    this.onQn123.q2 = null;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn2Change(answer: string) {
  if (answer === 'yes') {
    this.showQn3 = true;
    this.onQn123.q2 = true;
  } else {
    this.showQn3 = false;
    this.onQn123.q2 = false;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn3Change(value: string) {
  if (value === 'export') {
    this.showDutyInput = true;
    this.onQn123.q3 = true;
  } else {
    this.showDutyInput = false;
    this.onQn123.q3 = false;
    this.dutyValuePercentage = 0;
  }
}








  
  saveLandingCost(modal?: any) {
  const payload: any = {};

  if (this.onQn123.q1 === true) {
    payload.landingcost = true;

    if (this.onQn123.q2 === true) {
      payload.dutiesofcalclandingcost = true;

      if (this.onQn123.q3 !== null) {
        payload.dutyvalue = this.onQn123.q3;

        if (this.onQn123.q3 === true && this.dutyValuePercentage !== null) {
          payload.dutyvaluepercentage = this.dutyValuePercentage;
        }
      }
    } else {
      payload.dutiesofcalclandingcost = false;
    }

  } else {
    payload.landingcost = false;
  }

  console.log("Final Payload:", payload);

  if (modal) {
    modal.close(payload);
  } else {
    this.modalService.dismissAll();
  }
}

  // closeLandingCost(){

  // }
  closeLandingCost(modal?: any) {
    this.resetQuestions();
    if (modal) {
      modal.close();  // Close the popup
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;

  }
  getProgressBarColor(progress: number): string {
    if (progress < 50) {
      return 'warn'; // Light Red for less than 50%
    } else if (progress >= 50 && progress < 100) {
      return 'accent'; // Light Yellow for 50% to 99%
    }
    return 'primary'; // Light Blue for 100%
  }

  getProgressColor(progress: string | number): string {
    // Parse progress to get numeric value
    let progressValue = 0;
    
    if (typeof progress === 'string') {
      progressValue = parseInt(progress.replace('%', ''), 10);
    } else if (typeof progress === 'number') {
      progressValue = progress;
    }

    // Return light color based on progress range
    if (progressValue < 50) {
      return '#FFCDD2'; // Light Red/Pink for <50%
    } else if (progressValue >= 50 && progressValue <= 75) {
      return '#FFF9C4'; // Light Yellow for 50-75%
    } else {
      return '#C8E6C9'; // Light Green for >75%
    }
  }

  editProjectRow(customer: any): void {

    if (customer) {
      this.selectedmatchedCustomerData = customer;
      this.editingRowId = Number(customer.project_id);
    }
  }

  isRowEditing(projectId: number): boolean {
    return this.editingRowId === projectId;
  }


  onChangeAssignTo(event: any, customer: any): void {
    const engineerId = Number(event.target.value);

    // Find the selected engineer
    const selectedEngineer:any = this.engineersData.find((user:any) => user.engineer_id === engineerId);

    if (selectedEngineer) {
      console.log('Selected Engineer Name:', selectedEngineer.engineer_name);

      // Update all rows in matchedCustomerData with the same project_id
      this.matchedCustomerData.forEach(row => {
        if (row.project_id === customer.project_id) {
          // Update the engineer name and assigned ID
          row.engineer_name = selectedEngineer.engineer_name;
          row.assigned_to_id = engineerId;
          row.currentstage = customer.currentstage;
          // this.changedstage = customer.currentstage;

          // Optionally, set a default currentstage if needed
          if (!row.currentstage || row.currentstage.trim() === '') {
            row.currentstage = ''; // Example placeholder
            this.notify.info('Please select stage');
          }
        }
      });

      // Notify the user to select the stage
    }
  }


  onChangeStage(eve: any) {

    let changedtage = eve.target.value
    this.changedstage = changedtage
    console.log('val', changedtage);

  }

  onRowSelect(customer: any) {
    let role:any = sessionStorage.getItem('role');
    const fromProcurement = this.activeTab === 2;

    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer?.selectedVersionData?.project_id);
    if (customerIndex !== -1) {
      this.matchedCustomerData[customerIndex].version_id = Number(customer?.selectedVersionData?.version_id);
      console.log(this.matchedCustomerData[customerIndex].version_id);
      this.selectedVersionId = Number(customer?.selectedVersionData?.version_id);
      this.selectedProjectId = Number(customer?.selectedVersionData?.project_id);
      this.selectedProjectName = String(customer?.selectedVersionData?.projectName);
      sessionStorage.setItem('project_id', String(this.selectedProjectId));
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      
      if (fromProcurement) {
        const procurementVersionId = Number(customer?.selectedVersionData?.procurement_version_id || 0);
        sessionStorage.setItem('procurement_version_id', String(procurementVersionId));
        sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer?.selectedVersionData));
        this.menuService.setRole(role);
        
        this.router.navigate(['/project-view'], {
          state: { 
            customerInfo: customer?.selectedVersionData, 
            groupInfo: customer,
            startIndex: this.paginatestartIndex,
            endIndex: this.paginateendIndex,
            currentPage: this.currentPage,
            rowsPerPage: this.rowsPerPage,
            activeTab: this.activeTab,
            selectedProjectId: customer?.selectedVersionData?.project_id,
            selectedVersionId: this.selectedVersionId,
            fromProcurement: true,
            procurementVersionId: procurementVersionId,
            matchedData: this.matchedCustomerData 
          }
        });
      } else {
        this.menuService.setRole(role);
        if (this.selectedVersionId) {
          sessionStorage.setItem('procurement_version_id', '0');
          sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer?.selectedVersionData));
          this.router.navigate(['/project-view'], {
            state: { 
              customerInfo: customer?.selectedVersionData, 
              groupInfo: customer,
              startIndex: this.paginatestartIndex,
              endIndex: this.paginateendIndex,
              currentPage: this.currentPage,
              rowsPerPage: this.rowsPerPage,
              activeTab: this.activeTab,
              selectedProjectId: customer?.selectedVersionData?.project_id,
              selectedVersionId: this.selectedVersionId,
              fromProcurement: false,
              matchedData: this.matchedCustomerData 
            }
          });
        } else {
          this.notify.info('Please select version_id.')
        }
      }
    }
  }

  openApprovalModal(approvalModal: any, group: any): void {
    this.selectedApprovalProject = group;
    this.approvalReviewComments = '';
    this.showReworkCommentBox = false;
    this.selectedApprovalStatus = 'Approved'; // Reset to Approved default
    this.modalRef = this.modalService.open(approvalModal, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'md',
    });
  }

  closeApprovalModal(): void {
    this.selectedApprovalProject = null;
    this.approvalReviewComments = '';
    this.showReworkCommentBox = false;

    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    } else {
      this.modalService.dismissAll();
    }
  }

  prepareRework(): void {
    this.showReworkCommentBox = true;
  }

  submitApproval(action: 'APPROVE_PROJECT' | 'SEND_FOR_REWORK'): void {
    if (!this.selectedApprovalProject?.selectedVersionData || this.isApprovalSubmitting) {
      return;
    }

    if (action === 'SEND_FOR_REWORK' && !this.approvalReviewComments.trim()) {
      this.notify.info('Please enter comments before sending for rework.');
      return;
    }

    const selectedData = this.selectedApprovalProject.selectedVersionData;
    const payload: any = {
      action,
      project_id: Number(selectedData?.project_id ?? this.selectedApprovalProject?.project_id ?? 0),
      version_id: Number(selectedData?.version_id ?? 0),
      procurement_version_id: Number(selectedData?.procurement_version_id ?? 0),
      projectName: selectedData?.projectName ?? this.selectedApprovalProject?.projectName ?? '',
      created_by_id: Number(selectedData?.created_by_id ?? this.userId ?? 0),
      assigned_to_id: Number(selectedData?.assigned_to_id ?? 0),
      approval_status: selectedData?.approval_status ?? 'Pending',
    };

    if (action === 'SEND_FOR_REWORK') {
      payload.review_comments = this.approvalReviewComments.trim();
    }

    this.isApprovalSubmitting = true;
    this.masterService.manage_projects(payload).subscribe({
      next: (response: any) => {
        if (response?.status === 'success') {
          this.notify.success(
            action === 'APPROVE_PROJECT'
              ? 'Project approved successfully.'
              : 'Project sent for rework successfully.'
          );
          this.closeApprovalModal();
          const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
          this.getAllProjectData(currentStage);
        } else {
          this.notify.danger(response?.message || 'Unable to process the approval request.');
        }
      },
      error: (error) => {
        console.error('Approval action failed:', error);
        this.notify.danger('Failed to process the approval request.');
      },
      complete: () => {
        this.isApprovalSubmitting = false;
      }
    });
  }

  submitApprovalManager(): void {
    if (!this.selectedApprovalProject?.selectedVersionData || this.isApprovalSubmitting) {
      return;
    }

    if ((this.selectedApprovalStatus === 'Rework Required' || this.selectedApprovalStatus === 'Rejected') && !this.approvalReviewComments.trim()) {
      this.notify.info(`Please enter comments before submitting ${this.selectedApprovalStatus}.`);
      return;
    }

    const selectedData = this.selectedApprovalProject.selectedVersionData;
    
    // Determine the action code to send to the API based on selected status
    let action = 'APPROVE_PROJECT';
    if (this.selectedApprovalStatus === 'Rework Required') {
      action = 'SEND_FOR_REWORK';
    } else if (this.selectedApprovalStatus === 'Rejected') {
      action = 'REJECT_PROJECT';
    }

    const payload: any = {
      action,
      project_id: Number(selectedData?.project_id ?? this.selectedApprovalProject?.project_id ?? 0),
      version_id: Number(selectedData?.version_id ?? 0),
      procurement_version_id: Number(selectedData?.procurement_version_id ?? 0),
      projectName: selectedData?.projectName ?? this.selectedApprovalProject?.projectName ?? '',
      created_by_id: Number(selectedData?.created_by_id ?? this.userId ?? 0),
      assigned_to_id: Number(selectedData?.assigned_to_id ?? 0),
      approval_status: this.selectedApprovalStatus,
    };

    if (this.selectedApprovalStatus === 'Rework Required' || this.selectedApprovalStatus === 'Rejected') {
      payload.review_comments = this.approvalReviewComments.trim();
    }

    this.isApprovalSubmitting = true;
    this.masterService.manage_projects(payload).subscribe({
      next: (response: any) => {
        if (response?.status === 'success') {
          this.notify.success(`Project ${this.selectedApprovalStatus.toLowerCase()} successfully.`);
          this.closeApprovalModal();
          const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
          this.getAllProjectData(currentStage);
        } else {
          this.notify.danger(response?.message || 'Unable to process the approval request.');
        }
      },
      error: (error) => {
        console.error('Approval action failed:', error);
        this.notify.danger('Failed to process the approval request.');
      },
      complete: () => {
        this.isApprovalSubmitting = false;
      }
    });
  }

  getApprovalStatusLabel(group: any): string {
    return group?.selectedVersionData?.approval_status || 'Pending';
  }

}

